import React from 'react';
import { useParams } from 'react-router-dom';
import BoardList from '../components/Board/BoardList';

const BoardPage: React.FC = () => {
  const { category } = useParams<{ category: string }>();
  return <BoardList category={category || 'notice'} />;
};

export default BoardPage; 